export default [
  {
    path: '/ci/received',
    name: 'ci_received',
    component: () => import('./ReceivedCi.vue'),
    meta: {
      name: 'CI - Recebidos',
      auth: true,
      user: 'Admin',
    },
  },
]
